module.exports = __webpack_public_path__ + "static/media/life-overview-intro1.81cf01a5.png";